import React from "react";
var __jsx = React.createElement;
import FiveCardNva from './FiveCardNva';
function FiveCardNvaAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(FiveCardNva, {
    fiveCardNvaData: entry,
    scrollBarWidth: data.scrollBarWidth
  });
}
export default FiveCardNvaAdapter;